import BaseComponent from '../../../../base/base_component';
import SpainGameStripePC from './pc/spain_game_stripe_pc';
import Device from '../../../../utils/device/device';
import SpainGameStripeMobile from './mobile/spain_game_stripe_mobile';

export  const SPAIN_STRIP_COMPONENT_SELECTOR = 'cgp-spain-stripe-component';

export default class SpainGameStripeComponent extends BaseComponent {
    static CLASS = 'SpainGameStripeComponent';

    _selector = SPAIN_STRIP_COMPONENT_SELECTOR;

    _innerStripeComponent = null;

    init(params) {
        super.init(params);

        if (Device.os.isMobileOS) {
            this._innerStripeComponent = this.serviceFactory.componentFactoryService().createComponent(SpainGameStripeMobile);
        } else {
            this._innerStripeComponent = this.serviceFactory.componentFactoryService().createComponent(SpainGameStripePC);
        }

        this.appendChildComponent(this._innerStripeComponent);

        //init all fields with 0
        this.setRegulationData({
            sessionTotalBet: 0,
            sessionTotalWin: 0
        });
    }

    setRegulationData(regulationData) {
        this._innerStripeComponent.setRegulationData({
            sessionTotalBet: regulationData.sessionTotalBet,
            sessionTotalWin: regulationData.sessionTotalWin,
            sessionBalance: regulationData.sessionTotalWin - regulationData.sessionTotalBet
        });
    }
}